<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex>
        <v-tabs color="transparent" v-model="active" slider-color="secondary">
          <v-tab ripple>Users</v-tab>
          <v-tab ripple>Backup</v-tab>

          <v-tab-item>
            <users/>
          </v-tab-item>

          <v-tab-item>
            <backup/>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Backup from "./backups.vue";
import Users from "./users.vue";
export default {
  middleware: "admin",
  components: {
    Backup,
    Users
  },
  data() {
    return {
      active: null
    };
  }
};
</script>

<style scoped>
</style>